// extracted by mini-css-extract-plugin
export var errorInput = "Y_c5";
export var errorLabel = "Y_c2";
export var inputContainer = "Y_c6";
export var inputNumber = "Y_c7";
export var inputPercentage = "Y_c8";
export var textInput = "Y_c9";
export var textInputDefault = "Y_db";
export var textlabel = "Y_c3";